// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-6cf5911d]:after{content:normal}.ec-conteiner[data-v-6cf5911d]{padding:10px}.ec[data-v-6cf5911d]{line-height:40px;margin:0;padding:10px 10px 0}.ec__text-align-center[data-v-6cf5911d]{text-align:center}.ec__text-header[data-v-6cf5911d]{font-size:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
